import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-vc-delete-confirmation',
    templateUrl: './vc-delete-confirmation.component.html',
    styleUrls: ['./vc-delete-confirmation.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VcDeleteConfirmationComponent implements OnInit {

  constructor(
    public translate: TranslateService) { }

  ngOnInit(): void {
  }

}
